__turbopack_context__.v({
  "container": "Yr7Xxq_container",
  "offsetLeft": "Yr7Xxq_offsetLeft",
  "offsetRight": "Yr7Xxq_offsetRight",
  "quote": "Yr7Xxq_quote",
});
